(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dronearos-announcement-bar"]) return;
  try {
    
(function () {
  function bind(root) {
    if (!root || root.dataset.dbAbBound === '1') return;
    root.dataset.dbAbBound = '1';
    if (root.getAttribute('data-db-ab-collapse') !== 'true') return;
    var lastY = window.scrollY || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function onScroll() {
      var y = window.scrollY || 0;
      if (y > 80 && y > lastY + 2) {
        root.classList.add('is-collapsed');
      } else if (y < lastY - 6 || y <= 8) {
        root.classList.remove('is-collapsed');
      }
      lastY = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  function init() {
    document.querySelectorAll('[data-db-ab]').forEach(bind);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini2-difference"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad2(n) {
    return (n < 10 ? '0' : '') + String(n);
  }

  function bind(root) {
    if (!root || root.dataset.m2DiffBound === '1') return;
    root.dataset.m2DiffBound = '1';
    var rail = root.querySelector('[data-m2-diff-rail]');
    var counter = root.querySelector('[data-m2-diff-counter]');
    var prev = root.querySelector('[data-m2-diff-prev]');
    var next = root.querySelector('[data-m2-diff-next]');
    var hotspots = root.querySelectorAll('[data-m2-diff-hotspot]');
    if (!rail) return;
    var cards = rail.querySelectorAll('.m2-diff__card');
    var total = cards.length;
    if (!total) return;
    var current = 0;

    function paint() {
      rail.style.transform = 'translate3d(-' + (current * 100) + '%, 0, 0)';
      if (counter) counter.textContent = pad2(current + 1) + ' / ' + pad2(total);
      if (prev) prev.disabled = current <= 0;
      if (next) next.disabled = current >= total - 1;
      for (var i = 0; i < hotspots.length; i++) {
        var on = i === current;
        hotspots[i].classList.toggle('is-on', on);
        hotspots[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }

    function goTo(i) {
      current = Math.max(0, Math.min(total - 1, i));
      paint();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(current - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        goTo(current + 1);
      });
    }
    for (var h = 0; h < hotspots.length; h++) {
      (function (idx) {
        hotspots[idx].addEventListener('click', function () {
          goTo(idx);
        });
      })(h);
    }

    var startX = 0;
    var tracking = false;
    rail.addEventListener('touchstart', function (e) {
      if (!e.changedTouches || !e.changedTouches[0]) return;
      startX = e.changedTouches[0].clientX;
      tracking = true;
    }, { passive: true });
    rail.addEventListener('touchend', function (e) {
      if (!tracking || !e.changedTouches || !e.changedTouches[0]) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < 40) return;
      if (dx < 0) goTo(current + 1);
      else goTo(current - 1);
    }, { passive: true });

    paint();
  }

  function init() {
    document.querySelectorAll('[data-m2-diff]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  document.addEventListener('shopify:section:select', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini2-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function sprHasContent(root) {
    var spr = root.querySelector('#shopify-product-reviews');
    if (!spr) return false;
    if (spr.querySelector('.spr-review')) return true;
    return false;
  }
  function sync(root) {
    if (!root) return;
    root.classList.toggle('is-hydrated', sprHasContent(root));
  }
  function openWriteForm(root) {
    var spr = root && root.querySelector('#shopify-product-reviews');
    var productId = spr ? spr.getAttribute('data-id') : null;
    var nativeBtn = root && root.querySelector('.spr-summary-actions-newreview');
    if (nativeBtn) {
      nativeBtn.click();
      return;
    }
    if (window.SPR && typeof window.SPR.toggleForm === 'function' && productId) {
      window.SPR.toggleForm(productId);
      return;
    }
    var form = root && root.querySelector('.spr-form');
    if (form) {
      form.style.display = 'block';
      return;
    }
  }
  function init() {
    var root = document.getElementById('m2-reviews');
    sync(root);
    if (root && !root.dataset.m2RevObs && window.MutationObserver) {
      root.dataset.m2RevObs = '1';
      new MutationObserver(function () { sync(root); }).observe(root, { childList: true, subtree: true });
    }
    if (root && !root.dataset.m2WriteBound) {
      root.dataset.m2WriteBound = '1';
      var writeBtn = root.querySelector('[data-m2-write-review]');
      if (writeBtn) {
        writeBtn.addEventListener('click', function () { openWriteForm(root); });
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini2-scene"] && !Shopify.designMode) return;
  try {
    
(function () {
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function setCompare(root, pct) {
    pct = clamp(pct, 0, 100);
    var before = root.querySelector('.m2-compare__before');
    var divider = root.querySelector('.m2-compare__divider');
    var range = root.querySelector('.m2-compare__range');
    if (before) before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
    if (divider) divider.style.left = pct + '%';
    if (range) {
      if (String(range.value) !== String(Math.round(pct))) range.value = String(Math.round(pct));
      range.setAttribute('aria-valuenow', String(Math.round(pct)));
    }
  }

  function pointerPct(root, event) {
    var rect = root.getBoundingClientRect();
    if (!rect.width) return 50;
    return ((event.clientX - rect.left) / rect.width) * 100;
  }

  function currentPct(root) {
    var divider = root.querySelector('.m2-compare__divider');
    var raw = divider && divider.style.left ? parseFloat(divider.style.left) : 50;
    return isNaN(raw) ? 50 : raw;
  }

  function bindCompare(root) {
    if (root.dataset.m2Bound === '1') return;
    root.dataset.m2Bound = '1';

    var mode = 'idle';
    var pointerId = null;
    var startX = 0;
    var startY = 0;
    var latestPct = 50;
    var raf = 0;

    function paint() {
      raf = 0;
      setCompare(root, latestPct);
    }

    function queue(pct) {
      latestPct = pct;
      if (!raf) raf = requestAnimationFrame(paint);
    }

    function teardown() {
      mode = 'idle';
      pointerId = null;
      root.classList.remove('is-dragging');
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
      document.removeEventListener('pointercancel', onUp);
    }

    function onMove(event) {
      if (pointerId != null && event.pointerId !== pointerId) return;
      if (mode === 'pending') {
        var dx = event.clientX - startX;
        var dy = event.clientY - startY;
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (Math.abs(dx) > Math.abs(dy)) {
          mode = 'compare';
          root.classList.add('is-dragging');
        } else {
          teardown();
          return;
        }
      }
      if (mode === 'compare') {
        queue(pointerPct(root, event));
        if (event.cancelable) event.preventDefault();
      }
    }

    function onUp(event) {
      if (pointerId != null && event.pointerId !== pointerId) return;
      teardown();
    }

    root.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      var pct = pointerPct(root, event);
      if (Math.abs(pct - currentPct(root)) <= 12) {
        mode = 'compare';
        root.classList.add('is-dragging');
        queue(pct);
      } else {
        mode = 'pending';
      }
      document.addEventListener('pointermove', onMove, { passive: false });
      document.addEventListener('pointerup', onUp, { passive: true });
      document.addEventListener('pointercancel', onUp, { passive: true });
    });

    var range = root.querySelector('.m2-compare__range');
    if (range) {
      range.addEventListener('input', function () {
        setCompare(root, Number(range.value));
      });
    }
    setCompare(root, 50);
  }

  function bindLands(wrap) {
    if (!wrap || wrap.dataset.m2LandBound === '1') return;
    wrap.dataset.m2LandBound = '1';
    var slides = wrap.querySelectorAll('.m2-scene__land');
    var dotsRoot = wrap.parentElement && wrap.parentElement.querySelector('[data-m2-land-dots]');
    var dots = dotsRoot ? dotsRoot.querySelectorAll('[data-m2-land-dot]') : [];
    var raf = 0;

    function gap() {
      var cs = getComputedStyle(wrap);
      return parseFloat(cs.columnGap || cs.gap) || 0;
    }

    function activeIndex() {
      var w = slides[0] ? slides[0].offsetWidth + gap() : 1;
      var i = Math.round(wrap.scrollLeft / w);
      if (i < 0) i = 0;
      if (i > slides.length - 1) i = slides.length - 1;
      return i;
    }

    function paint() {
      raf = 0;
      var i = activeIndex();
      dots.forEach(function (dot, n) {
        if (n === i) dot.classList.add('is-active');
        else dot.classList.remove('is-active');
      });
    }

    function queue() {
      if (!raf) raf = requestAnimationFrame(paint);
    }

    wrap.addEventListener('scroll', queue, { passive: true });
    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () {
        var w = slides[0] ? slides[0].offsetWidth + gap() : 0;
        wrap.scrollTo({ left: n * w, behavior: 'smooth' });
      });
    });
    paint();
  }

  function initScene() {
    document.querySelectorAll('[data-m2-compare]').forEach(bindCompare);
    document.querySelectorAll('[data-m2-scene-lands]').forEach(bindLands);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScene);
  } else {
    initScene();
  }
  document.addEventListener('shopify:section:load', initScene);
  document.addEventListener('shopify:section:reorder', initScene);
})();

  } catch(e) { console.error(e); }
})();
})();
